import { useLocation, useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import 'react-best-tabs/dist/index.css'
import { Billing } from '../../profile/components/Billing'
import LockIcon from '../../../../media/Generic/ic-lock-black.svg'
import { useEffect, useState } from 'react'
import { useAuth } from '../../auth'
import useGetBillingData from '../../../hooks/useGetBillingData'
import '../../../../app/modules/widgets/components/styles/rectangularTabs.scss'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { PageTitle } from '../../../../_metronic/layout/core'
import { SettingsBreadCrum } from '../core/_constants'
import StorageAndAIUse from '../../profile/components/StorageAndAIUse'
import brandingConfig from '../../../../config/brandingConfig'

const BillingAndInvoice = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tabParam = params.get('tab')
    const tabIndex = options.findIndex((opt) => opt.slug.toLowerCase() === tabParam?.toLowerCase())
    if (tabIndex !== -1) {
      setTab(tabIndex + 1)
    } else {
      setTab(1) // Default to the first tab
      navigate(`${location.pathname}?tab=${options[0].slug.toLowerCase()}`)
    }
  }, [location.search]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleTabChange = (index: number) => {
    setTab(index + 1)
    navigate(`${location.pathname}?tab=${options[index].slug.toLowerCase()}`)
  }

  console.log('location checking', location)
  const { formatMessage } = useIntl()
  const [key] = useState(1)
  const [loading, setLoading] = useState(false)

  const {
    companyId,
    setCurrentState,
    selected,
    setSelected,
    setCurrencyBill,
    billingData,
    setBillingData,
    setShowBillingModal,
    setEntitlements,
    setCompanyCurrency,
    currentUser,
    planStatus,
  } = useAuth()

  const { getBillingDetailsAPI, onAccessBillingPortal } = useGetBillingData(companyId!)

  // api calling starts

  //Billing API Call

  useEffect(() => {
    const plan: any = billingData?.subscription_items[0].item_price_id?.split('-')
    if (plan) {
      setSelected(plan[0])
      setCurrencyBill(plan[1])
      setCompanyCurrency(currentUser?.company[0]?.currency?.code)
      setCurrentState(plan[2])
    }
  }, [billingData]) // eslint-disable-line react-hooks/exhaustive-deps

  const getBillingDetails = async () => {
    setLoading(true)
    const result = await getBillingDetailsAPI()
    setBillingData({
      ...result.output,
      ...result.customer_info,
      renewal_estimate: result.renewal_estimate,
      transaction_id: result.current_plan_invoice_id,
      company_country:result.company_country
    })
    setEntitlements(result.entitlement_list as any[])
    setLoading(false)
  }

  useEffect(() => {
    if (companyId) {
      getBillingDetails()
    }
  }, [companyId,key,planStatus]) // eslint-disable-line react-hooks/exhaustive-deps

  // api calling ends

  const [tab, setTab] = useState(1)

  const options = [
    {
      title: formatMessage({ id: 'Billing' }),
      subTitle: formatMessage({ id: 'Billing Settings' }),
      slug: formatMessage({ id: 'billing' }),
    },
    {
      title: formatMessage({ id: 'Storage and AI Usage' }),
      subTitle: formatMessage({ id: 'Storage and AI Usage Quota Settings' }),
      slug: formatMessage({ id: 'storage-and-ai-usage' }),
    },
  ]

  const filteredOptions =
    brandingConfig.brandName === 'Foundercrate' ? options.slice(0, options.length - 1) : options

  return (
    <div className='px-6 d-md-flex flex-md-column align-items-start row'>
      {/* <div className='d-md-flex d-flex justify-content-md-between w-100 pt-1 mb-4 col-12'>
        <div className='page-title d-flex flex-column justify-content-center flex-wrap me-3'>
          <h1 className='page-heading d-flex text-dark fw-bold fs-4 flex-column justify-content-center'>
            {formatMessage({ id: 'Company Settings' })}
          </h1>
          <ul className='breadcrumb breadcrumb-separatorless fw-semibold font-size-12 my-2'>
            <li className='breadcrumb-item text-muted'>
              <a href='/' className='text-primary'>
                {formatMessage({ id: 'Home' })}
              </a>
            </li>
            <li className='breadcrumb-item'>
              <span className='h-1px bullet'></span>
            </li>
            <li className='breadcrumb-item text-muted text-dark'>
              {formatMessage({ id: 'Company Settings' })}
            </li>
          </ul>
        </div>
        <Toolbar />
      </div> */}

      <PageTitle
        breadcrumbs={SettingsBreadCrum}
        description={formatMessage({ id: 'Billing and Invoices' })}
      >
        {formatMessage({ id: 'Billing and Invoices' })}
      </PageTitle>

      <div
        className='p-0'
        style={{
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        <div
          className='d-flex gap-3 px-md-3 col-md-8 col-12'
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {filteredOptions.map((opt, index) => (
            <div
              key={index}
              className={
                `col options-container p-4 cursor-pointer  border border-muted` +
                (tab === index + 1 ? ' selected-option  border-primary' : '')
              }
              style={{
                width: '200px',
                flex: '0 0 auto',
                borderRadius: '8px',
                padding: '18px, 12px, 18px, 12px',
                gap: '10px',
                overflow: 'hidden',
              }}
              onClick={() => {
                handleTabChange(index)
                if (
                  index + 1 === 5 &&
                  billingData?.subscription_items[0].item_price_id.split('-')[0] !== 'Gold'
                ) {
                  setShowBillingModal(true)
                }
              }}
            >
              <div className='d-flex align-items-center gap-1'>
                {index + 1 === 5 && (
                  <img
                    src={toAbsoluteUrl(LockIcon)}
                    alt='lock icon'
                    width={18}
                    className={`${billingData?.subscription_items[0].item_price_id.split('-')[0] !== 'Gold'
                        ? ''
                        : 'd-none'
                      }`}
                    height={18}
                  />
                )}
                <h1 className='m-0'>{formatMessage({ id: opt.title })}</h1>
              </div>
              <p
                className='mt-2'
                style={{
                  width: '100%',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  overflow: 'visible',
                }}
              >
                {formatMessage({ id: opt.subTitle })}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className='mt-4 mb-9 w-100 px-0 px-md-3'>
        {tab === 1 && (
          <Billing
            key={key}
            billingData={billingData}
            selected={selected}
            setSelected={setSelected}
            onAccessBillingPortal={onAccessBillingPortal}
            getBillingDetails={getBillingDetails}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        {tab === 2 && <StorageAndAIUse />}
      </div>
    </div>
  )
}
export { BillingAndInvoice }
